<template>
  <RightInfoPanelGeneric
    :value="formData"
    :title-key="'scale.weighing_on_scale.title_info_date'"
    :items="computedItems"
    :saving="saving"
    @save="$emit('save')"
    @back="onBack"
  >
    <div v-if="weighing_finished" class="warning-message">
      {{ "* " + $t("scale.weighing_on_scale.unfinished_weighing") }}
    </div>
  </RightInfoPanelGeneric>
</template>

<script>
import RightInfoPanelGeneric from '@/components/Common/RightInfoPanelGeneric.vue';

export default {
  name: "RightInfoPanel",
  components: {
    RightInfoPanelGeneric,
  },
  props: {
    formData: {
      type: Object,
      required: true,
    },
    saving: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    weighing_finished() {
      if ((this.formData.full_weight_kg ?? 0) > 0 && ((this.formData.empty_weight_kg ?? 0) >= 0 && this.formData.empty_datetime)) {
        return false;
      }
      return true;
    },
    getSelectedParcelSurfaceDecimal() {
      return this.formData.selectedParcels && this.formData.selectedParcels.length > 0
        ? this.formData.selectedParcels
            .map((l) => l.surface)
            .reduce((x, y) => {
              return (parseFloat(x) + parseFloat(y)).toFixed(2);
            })
        : 0;
    },
    getSelectedParcelCountForInput() {
      return (
        "" +
        this.formData.selectedParcels.length +
        (this.formData.selectedParcels.length == 1 ? " parcelă selectată" : " parcele selectate") +
        " (" +
        this.getSelectedParcelSurfaceDecimal +
        " ha)"
      );
    },
    computedItems() {
      const items = [
        {
          labelKey: 'common.weighing_type',
          path: 'weighing_type',
          required: true,
        },
        {
          labelKey: 'scale.weighing_on_scale.scale_house',
          path: 'scale_house_name',
          required: true,
        },
        {
          labelKey: 'common.date',
          path: 'date',
          required: true,
        },
        {
          labelKey: 'scale.weighing_on_scale.tractor_number_plate',
          path: 'tractor_number_plate',
          required: true,
        },
        {
          labelKey: 'scale.weighing_on_scale.driver_name',
          path: 'driver_name',
          required: true,
        },
        {
          labelKey: 'scale.weighing_on_scale.vehicle_configuration',
          path: 'vehicle_configuration',
          required: true,
        },
        {
          labelKey: 'scale.weighing_on_scale.empty_weight',
          path: 'empty_weight_kg',
          required: false,
        },
        {
          labelKey: 'scale.weighing_on_scale.full_weight',
          path: 'full_weight_kg',
          required: false,
        },
        {
          labelKey: 'scale.weighing_on_scale.buyer_seller_name',
          path: 'buyer_seller_name',
          required: true,
        },
      ];

      // Add conditional fields based on weighing_type_id
      if (this.formData.weighing_type_id !== 5) {
        items.push({
          labelKey: 'common.warehouse',
          path: 'recipient_warehouse_name',
          required: true,
          formatter: (val, data) => {
            return val ?? data.issuer_warehouse_name;
          },
        });
      }

      if (this.formData.weighing_type_id !== 6) {
        items.push({
          labelKey: 'common.partner',
          path: 'partner_name',
          required: true,
        });
      }

      if (this.formData.weighing_type_id === 6) {
        items.push({
          labelKey: 'common.parcels',
          path: 'selectedParcels',
          required: true,
          formatter: () => this.getSelectedParcelCountForInput,
        });
      }

      items.push({
        labelKey: 'common.product',
        path: 'product_name',
        required: true,
      });

      return items;
    },
  },
  methods: {
    onBack() {
      this.$router.push({
        name: "weighing-on-scale",
      });
    },
  },
};
</script>

<style scoped>
.warning-message {
  color: #ff9800;
  font-size: 12px;
  margin-top: 10px;
  padding: 10px;
  text-align: center;
}
</style>
